export const isValidValidationResult = result => {
  return result.status === 'VALID';
};
export const isPendingValidationResult = result => {
  return result.status === 'PENDING';
};
export const isInvalidValidationResult = result => {
  return result.status === 'INVALID';
};